<template>
  <v-container class="section mt-16 pt-8">
    <!-- The section heading -->
    <div
      class="font-weight-bold bluegray--text text-h4 text-center"
      v-vue-aos.once="{ animationClass:'fadeIn slow animated delay-1s' }"
    >
      Brands Across Over <span class="primary--text">28 countries</span> <br /> are now powered by Klug
    </div>

    <!-- The subtitle -->
    <div
      class="section__subtitle text-center mt-4 px-md-12 px-lg-16 mx-lg-12"
      v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
    >
      Leading Group Agencies, Massive E-commerce Players, Influencer Marketing Agencies <br /> Big and Small Brands and the new breed of sharp marketing D2C brands across the world
    </div>

    <!-- The container for cards -->
    <v-row class="mt-8">
      <!-- The card column -->
      <v-col
        cols="12"
        class="d-flex justify-center"
        v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
      >
        <!-- The actual card -->
        <div class="card px-4 px-md-6 px-lg-12 py-8 text-center overflow-hidden">
          <!-- The image -->
          <!-- <v-img
            contain
            height="287"
            class="mb-14"
            src="/img/svg/join-1.svg"
            v-vue-aos.once="{ animationClass:'fadeIn slow animated delay-1s' }"
          /> -->

          <!-- The title -->
          <div class="card__title bluegray--text font-weight-bold">
            See Klug in Action
          </div>

          <!-- The subtext -->
          <div class="card__text mt-6">
            Just click below or email us at <span class="bluegray--text">contact@klugklug.com</span> <br /> and we can take it from there.
          </div>

          <!-- The action button -->
          <div class="mt-8">
            <v-btn
              large
              depressed
              color="primary"
              href="/#contact"
            >
              Request Demo
            </v-btn>
          </div>
        </div>
      </v-col>

      <!-- The card column -- >
      <v-col
        cols="12"
        md="6"
        class="d-flex justify-start"
        v-vue-aos.once="{ animationClass:'fadeIn slow animated delay-1s' }"
      >
        < !-- The actual card -- >
        <div class="card bluegray px-4 py-8 text-center overflow-hidden">
          < !-- The image -- >
          <v-img
            contain
            height="287"
            src="/img/svg/join-2.svg"
            v-vue-aos.once="{ animationClass:'fadeIn slow animated delay-1s' }"
          />

          < !-- The title -- >
          <div class="card__title mt-14 white--text font-weight-bold">
            Create Free Account
          </div>

          < !-- The subtext -- >
          <div class="card__text white--text mt-6">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec non eros ultrices, interdum elit id, cursus metus.
          </div>

          < !-- The action button -- >
          <div class="mt-8">
            <v-btn
              large
              depressed
              color="primary"
              :to="{ name: 'Register' }"
            >
              Get Started For Free
            </v-btn>
          </div>
        </div>
      </v-col>
    -->
    </v-row>
  </v-container>
</template>

<script>
// Export the SFC
export default {
  // Name of the component
  name: "JoinToday"
}
</script>

<style lang="stylus" scoped>
.section
  .card
    border-radius 8px
    // max-width 570px

    &:first-child
      background #F0F0F0

    &__title
      font-size 2em

    &__text
      font-size 1.125em
      font-weight 300
</style>
